export function getHasGretaAIChatRowMenuDivider(index) {
  return index > 0
}
